module.exports = __webpack_public_path__ + "static/media/pattern-2.aa1dd948.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/pattern-2.png
// module id = 4917
// module chunks = 14